import type { Components } from '@mui/material'

export const OmuiStatusBar: NonNullable<Components['OmuiStatusBar']> = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape['radius-full'],
      padding: theme.spacing(1.5, 2, 1.5, 3),
      '& > div': {
        minHeight: 28,
      },
      '& .OmuiStatusBar-actionContainer': {
        gap: theme.spacing(2),
      },
    }),
    message: ({ theme }) => ({
      ...theme.typography['body-medium'],
    }),
    divider: ({ theme }) => ({
      borderColor: theme.palette.border.subtle,
      borderRightWidth: theme.strokeWidth.default,
    }),
    icon: {
      '& .MuiCircularProgress-root': {
        color: 'inherit',
      },
    },
    closeButton: {
      width: 24,
      height: 24,
    },
  },
  variants: [
    {
      props: { variant: 'loading' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.bg.surface.elevated,
        color: theme.palette.text.default,
        borderWidth: theme.strokeWidth.default,
        borderColor: theme.palette.border.subtle,
        borderStyle: 'solid',

        '& .OmuiStatusBar-icon': {
          color: theme.palette.fg.default,
        },
      }),
    },
    {
      props: { variant: 'success' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.bg.success.default,
        color: theme.palette.text.success.onSuccess,
        '& .OmuiStatusBar-divider': {
          borderColor: theme.palette.border.transparent,
        },
        '& .OmuiStatusBar-icon': {
          color: theme.palette.fg.success.onSuccess,
        },
        '& .OmuiStatusBar-closeButton': {
          color: theme.palette.fg.success.onSuccess,
        },
      }),
    },
    {
      props: { variant: 'error' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.bg.danger.default,
        color: theme.palette.text.danger.onDanger,
        '& .OmuiStatusBar-divider': {
          borderColor: theme.palette.border.transparent,
        },
        '& .OmuiStatusBar-icon': {
          color: theme.palette.fg.danger.onDanger,
        },
        '& .OmuiStatusBar-closeButton': {
          color: theme.palette.fg.danger.onDanger,
        },
      }),
    },
    {
      props: { variant: 'warning' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.bg.warning.default,
        color: theme.palette.text.warning.onWarning,
        '& .OmuiStatusBar-divider': {
          borderColor: theme.palette.border.transparent_inverted,
        },
        '& .OmuiStatusBar-icon': {
          color: theme.palette.fg.warning.onWarning,
        },
        '& .OmuiStatusBar-closeButton': {
          color: theme.palette.fg.warning.onWarning,
        },
      }),
    },
  ],
}
